import type { NavigationMenu } from '@/types/navigation'
import DashboardIconOutlined from '@/assets/icons/dashboard-outlined.svg'
import PercentageIcon from '@/assets/icons/percentage.svg'
import { IconCalendar, IconAccount, IconCity } from '@accor/icons'

export const buildAabMenu = (): NavigationMenu => [
  {
    routeName: 'aab-dashboard',
    i18nLabel: 'aab.navigation.menu.dashboard.title',
    icon: { svg: DashboardIconOutlined },
    tracking: {
      name: 'company dashboard',
      position: 1,
      pagename: 'loyalty program::all accor business::account::homepage'
    }
  },
  {
    routeName: 'aab-loyalty-management',
    i18nLabel: 'aab.navigation.menu.loyalty.title',
    icon: { svg: PercentageIcon },
    tracking: {
      name: 'company loyalty page',
      position: 2,
      pagename: 'loyalty program::all accor business::account::loyalty page'
    }
  },
  {
    routeName: 'aab-bookings-management',
    i18nLabel: 'aab.navigation.menu.bookings.title',
    icon: { svg: IconCalendar },
    tracking: {
      name: 'company bookings',
      position: 3,
      pagename: 'loyalty program::all accor business::account::bookings'
    }
  },
  {
    routeName: 'aab-collaborators-management',
    i18nLabel: 'aab.navigation.menu.collaborators.title',
    icon: { svg: IconAccount },
    tracking: {
      name: 'company employees',
      position: 4,
      pagename: 'loyalty program::all accor business::account::team management'
    }
  },
  {
    routeName: 'aab-company-information',
    i18nLabel: 'aab.navigation.menu.companyInfo.title',
    icon: { svg: IconCity },
    tracking: {
      name: 'company information',
      position: 5,
      pagename: 'loyalty program::all accor business::account::company settings'
    }
  }
]
